import * as React from "react";
import {
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { Project } from "../../types/project";
import LoadingButton from "@mui/lab/LoadingButton";
import { useUpdateProjectInternalNotesMutation } from "../../services/project.service";
import { BaseModal, Button } from "../../components/global";

interface ModalInternalNotesFormProps {
  open: boolean;
  onClose: () => void;
  project: Project | null;
}

const ModalInternalNotesForm = ({
  open,
  onClose,
  project,
}: ModalInternalNotesFormProps) => {
  const {
    handleSubmit,
    clearErrors,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const [updateNotes, { isLoading }] = useUpdateProjectInternalNotesMutation();

  const onSubmit = async (payload: any) => {
    try {
      if (!project) return;

      await updateNotes({
        projectId: project?.id,
        internal_notes: payload.internal_notes,
        companyId: project.company_id,
      }).unwrap();
      onClose();
    } catch (err) {
      onClose();
    }
  };

  React.useEffect(() => {
    if (open) {
      setValue("internal_notes", project?.internal_notes);
      clearErrors();
    }
  }, [project, open]);

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Job Internal Notes"
      maxWidth="sm"
      useGlassCard={false}
      footer={
        <>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            loading={isLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </LoadingButton>
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" sx={{ color: "#F4A259", mb: 2 }}>
            *Not visible to talents
          </Typography>
          <Controller
            name="internal_notes"
            control={control}
            rules={{ required: true, min: 1 }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <TextField
                label="Notes"
                value={value || ""}
                fullWidth
                multiline={true}
                rows={8}
                onChange={onChange}
                onBlur={onBlur}
                inputRef={ref}
                error={!!errors.internal_notes}
                helperText={errors.internal_notes ? "Notes is required" : ""}
              />
            )}
          />
        </Box>
      </form>
    </BaseModal>
  );
};
export default ModalInternalNotesForm;
